"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCancelBackgroundCheckDto = instanceOfCancelBackgroundCheckDto;
exports.CancelBackgroundCheckDtoFromJSON = CancelBackgroundCheckDtoFromJSON;
exports.CancelBackgroundCheckDtoFromJSONTyped = CancelBackgroundCheckDtoFromJSONTyped;
exports.CancelBackgroundCheckDtoToJSON = CancelBackgroundCheckDtoToJSON;
exports.CancelBackgroundCheckDtoToJSONTyped = CancelBackgroundCheckDtoToJSONTyped;
/**
 * Check if a given object implements the CancelBackgroundCheckDto interface.
 */
function instanceOfCancelBackgroundCheckDto(value) {
    if (!('backgroundCheckId' in value) || value['backgroundCheckId'] === undefined)
        return false;
    return true;
}
function CancelBackgroundCheckDtoFromJSON(json) {
    return CancelBackgroundCheckDtoFromJSONTyped(json, false);
}
function CancelBackgroundCheckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'backgroundCheckId': json['backgroundCheckId'],
    };
}
function CancelBackgroundCheckDtoToJSON(json) {
    return CancelBackgroundCheckDtoToJSONTyped(json, false);
}
function CancelBackgroundCheckDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'backgroundCheckId': value['backgroundCheckId'],
    };
}
//# sourceMappingURL=CancelBackgroundCheckDto.js.map